import {DataFetcherRequest} from '@aboutyou/data-fetcher';
import {useEffect} from 'react';
import {NextPage} from './useTokenBasedStreamPages';

interface Props<T> {
  request: DataFetcherRequest<{
    items: unknown[];
    nextState: T | undefined | null;
  }>;
  page: NextPage<T>;
}

export const UpdateNextToken = <T,>({
  request,
  page: {setNextToken},
}: Props<T>) => {
  const nextToken = request.data?.nextState;

  useEffect(() => {
    // when the request is still loading/fetching, we don't want to set the token, basically the token will be undefined
    if (request.isLoading || request.isFetching) return;

    if (!request.data) return;

    // the nextToken is undefined when there are no more pages to load
    // in this case we set `null` explicitly to the historyState. If the nextToken is `null` we stop fetching the main stream and start the "additional product stream"
    if (nextToken === undefined) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setNextToken(null);
      return;
    }

    // eslint-disable-next-line local-rules/set-state-in-use-effect
    setNextToken(nextToken);
  }, [
    request.data,
    request.isLoading,
    request.isFetching,
    nextToken,
    setNextToken,
  ]);

  return null;
};
